import React from 'react';
import { useIntl } from 'react-intl';
import dynamic from 'next/dynamic';
import Typograghy from '@nubank/nuds-web/components/Typography/Typography';

import { maybeFormatMessage } from 'utils/i18nUtils';

import { Section, HeadingContainer } from './styles/Container';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

function SectionApp() {
  const intl = useIntl();

  return (
    <Section>
      <HeadingContainer>
        <Typograghy
          variant="title"
          intlKey="FGTS.APP.TITLE"
          gutterBottom={1.5}
          intlValues={{ br: <br /> }}
        />
        <Typograghy
          variant="subtitle"
          intlKey="FGTS.APP.SUBTITLE"
        />
      </HeadingContainer>
      <ResponsiveImages
        fileName="woman-with-yellow-glasses/woman-with-yellow-glasses.jpg"
        alt={maybeFormatMessage(intl, 'FGTS.APP', 'ALT_IMAGE')}
        loading="lazy"
        position="flex-end"
      />
    </Section>
  );
}

export default React.memo(SectionApp);
